import { useEffect, useState } from "react";

export const HALLOWEEN_END = Date.parse("2026-11-01T05:00:00Z");
export const isHalloween = () => Date.now() < HALLOWEEN_END;

export function useHalloween() {
  const [on, setOn] = useState(isHalloween);
  useEffect(() => {
    document.documentElement.classList.toggle("halloween", on);
    if (!on) return undefined;
    const t = setTimeout(() => setOn(false), Math.min(HALLOWEEN_END - Date.now(), 2 ** 31 - 1));
    return () => clearTimeout(t);
  }, [on]);
  return on;
}
